import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {baseLayerStyles} from 'src/app/constants/map';
import {MapboxGlService} from 'src/app/services/mapbox-gl.service';

@Component({
    selector: 'app-mapboxgl-change-style',
    templateUrl: './mapboxgl-change-style.component.html',
    styleUrls: ['./mapboxgl-change-style.component.scss'],
})
export class MapboxglChangeStyleComponent implements OnInit {

    public service: MapboxGlService;
    public baseLayerStyles = baseLayerStyles;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<MapboxglChangeStyleComponent>
    ) {
        this.service = this.data.service;
    }

    ngOnInit(): void {
    }

    setStyle(style): void {
        this.service.changeMapStyle(style).then();
        this.dialogRef.close();
    }

    close(): void {
        this.dialogRef.close();
    }

}
